// ABOUTME: Landing page study picker — one card per study family, each gated on that family
// ABOUTME: actually having data in this environment so a card never leads to an empty page.
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
})
export class HomepageComponent implements OnInit {
  public grch37Available = false;
  public v3Available = false;
  public isLoading = true;
  public error: HttpErrorResponse | undefined;

  constructor(
    private router: Router,
    private api: ApiService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkStudyAvailability();
  }

  /**
   * A study family is offered only where it has endpoints in THIS environment. v3 rolls out
   * environment by environment, so the card must stay hidden where its data has not landed yet.
   * Each check fails independently: one study being unreachable must not hide the others.
   */
  checkStudyAvailability(): void {
    this.spinner.show();
    this.error = undefined;
    forkJoin({
      gwas15: this.api.getGwas15Datasets().pipe(
        catchError((err: HttpErrorResponse) => {
          this.error = err;
          return of([]);
        })
      ),
      v3: this.api.getV3Datasets().pipe(catchError(() => of([]))),
    }).subscribe(({ gwas15, v3 }) => {
      this.grch37Available = gwas15.length > 0;
      this.v3Available = v3.length > 0;
      this.isLoading = false;
      this.spinner.hide();
    });
  }

  navigateToGWAS15(): void {
    if (this.grch37Available) {
      this.router.navigate(['/gwas-15']);
    }
  }

  navigateToGWAS16(): void {
    this.router.navigate(['/gwas-16']);
  }

  navigateToEnrollHd(): void {
    if (this.v3Available) {
      this.router.navigate(['/enroll-hd']);
    }
  }
}
